module.exports = __webpack_public_path__ + "media/src/images/icons/circular_arrow-8e2d71a75bd09a14b3b502a2612d8c70.svg";